import { startLoading, stopLoading } from "../common/utils/button-loading";
import { SubmitCommentResponse } from "./interfaces/http";
import { submitComment } from "./services/comment-service";

export default function setupAjaxComment(
	area: HTMLElement,
	renderFn: Function,
) {
	const form = area.querySelector(".ajax-comment-form") as HTMLFormElement;
	if (!form) return;

	const textarea = form.querySelector("textarea") as HTMLTextAreaElement | null;
	if (!textarea) return;

	const submitButton = form.querySelector(
		".submit-button",
	) as HTMLButtonElement | null;
	if (!submitButton) return;

	const postId = form.dataset.postId ? parseInt(form.dataset.postId) : 0;

	if (!postId) return;

	const parentField = form.querySelector(
		"[name='comment_parent']",
	) as HTMLInputElement | null;

	let doingAjax = false;

	form.addEventListener("submit", handleFormSubmit);

	async function handleFormSubmit(e: SubmitEvent) {
		e.preventDefault();
		if (!textarea) return;
		if (!textarea.value) return;
		await submit();
	}

	async function submit() {
		if (doingAjax) return;
		doingAjax = true;
		startLoading(submitButton!);

		const parentId = parentField ? parseInt(parentField.value) : 0;

		const response: SubmitCommentResponse = await submitComment({
			action: "pm_submit_comment",
			nonce: form.dataset.submitCommentNonce
				? form.dataset.submitCommentNonce
				: "",
			postId: postId,
			parentId: parentId,
			content: textarea!.value,
		});

		if (!response.success) {
			alert(response.message);
		} else {
			textarea!.value = "";
			renderFn(postId, parentId, response.data);
		}

		doingAjax = false;
		stopLoading(submitButton!);
	}
}
